
import OrderHistory from "@/components/dashboard/OrderHistory";
import { SEO } from "@/components/SEO";
import BackButton from "@/components/navigation/BackButton";

const OrdersPage = () => {
  return (
    <>
      <SEO title="My Orders" description="View your order history and track your purchases." />
      <div className="container mx-auto max-w-5xl py-8 px-4 sm:px-6 lg:px-8">
        <BackButton to="/profile" label="Back to Profile" />
        <h1 className="text-3xl font-bold tracking-tight text-foreground mb-8">My Orders</h1>
        <OrderHistory />
      </div>
    </>
  );
};

export default OrdersPage;
